import audioCompanionTtsScripts from "./audioCompanionTtsScripts.json";

interface CharacterVoiceDemoConfig {
  audioSrc: string;
  label: string;
  spokenText: string;
}

export const CHARACTER_VOICE_DEMO = audioCompanionTtsScripts.characterVoiceDemo as CharacterVoiceDemoConfig;
